import { render, staticRenderFns } from "./task-quick-review.vue?vue&type=template&id=5e460bce&scoped=true&"
import script from "./task-quick-review.vue?vue&type=script&lang=js&"
export * from "./task-quick-review.vue?vue&type=script&lang=js&"
import style0 from "./task-quick-review.vue?vue&type=style&index=0&id=5e460bce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e460bce",
  null
  
)

export default component.exports